/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrganizationRelationshipRequestDto,
  CreateOrganizationRelationshipResponseDto,
  UpdateOrganizationRelationshipRequestDto,
} from '../models/index';
import {
    CreateOrganizationRelationshipRequestDtoFromJSON,
    CreateOrganizationRelationshipRequestDtoToJSON,
    CreateOrganizationRelationshipResponseDtoFromJSON,
    CreateOrganizationRelationshipResponseDtoToJSON,
    UpdateOrganizationRelationshipRequestDtoFromJSON,
    UpdateOrganizationRelationshipRequestDtoToJSON,
} from '../models/index';

export interface OrganizationRelationshipControllerCreateRequest {
    createOrganizationRelationshipRequestDto: CreateOrganizationRelationshipRequestDto;
}

export interface OrganizationRelationshipControllerDeleteRequest {
    id: string;
}

export interface OrganizationRelationshipControllerFindByIdRequest {
    id: string;
}

export interface OrganizationRelationshipControllerUpdateRequest {
    id: string;
    updateOrganizationRelationshipRequestDto: UpdateOrganizationRelationshipRequestDto;
}

/**
 * 
 */
export class OrganizationRelationshipsApi extends runtime.BaseAPI {

    /**
     */
    async organizationRelationshipControllerCreateRaw(requestParameters: OrganizationRelationshipControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrganizationRelationshipResponseDto>> {
        if (requestParameters['createOrganizationRelationshipRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createOrganizationRelationshipRequestDto',
                'Required parameter "createOrganizationRelationshipRequestDto" was null or undefined when calling organizationRelationshipControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organization-relationships`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrganizationRelationshipRequestDtoToJSON(requestParameters['createOrganizationRelationshipRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrganizationRelationshipResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationRelationshipControllerCreate(requestParameters: OrganizationRelationshipControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrganizationRelationshipResponseDto> {
        const response = await this.organizationRelationshipControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationRelationshipControllerDeleteRaw(requestParameters: OrganizationRelationshipControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling organizationRelationshipControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organization-relationships/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async organizationRelationshipControllerDelete(requestParameters: OrganizationRelationshipControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.organizationRelationshipControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async organizationRelationshipControllerFindAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CreateOrganizationRelationshipResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organization-relationships`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CreateOrganizationRelationshipResponseDtoFromJSON));
    }

    /**
     */
    async organizationRelationshipControllerFindAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CreateOrganizationRelationshipResponseDto>> {
        const response = await this.organizationRelationshipControllerFindAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationRelationshipControllerFindByIdRaw(requestParameters: OrganizationRelationshipControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrganizationRelationshipResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling organizationRelationshipControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organization-relationships/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrganizationRelationshipResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationRelationshipControllerFindById(requestParameters: OrganizationRelationshipControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrganizationRelationshipResponseDto> {
        const response = await this.organizationRelationshipControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationRelationshipControllerUpdateRaw(requestParameters: OrganizationRelationshipControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling organizationRelationshipControllerUpdate().'
            );
        }

        if (requestParameters['updateOrganizationRelationshipRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateOrganizationRelationshipRequestDto',
                'Required parameter "updateOrganizationRelationshipRequestDto" was null or undefined when calling organizationRelationshipControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organization-relationships/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrganizationRelationshipRequestDtoToJSON(requestParameters['updateOrganizationRelationshipRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async organizationRelationshipControllerUpdate(requestParameters: OrganizationRelationshipControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.organizationRelationshipControllerUpdateRaw(requestParameters, initOverrides);
    }

}
